import { useAuth } from '@/app/providers/auth/authContext';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { WelcomePage } from '@/features/welcome/WelcomePage';
import { LoadingScreen } from '@/shared/ui/LoadingScreen';

/**
 * The start page depends on who is looking: guests see the public welcome,
 * signed-in captains their dashboard. Keeping that decision here means neither
 * page has to know about the other.
 */
export function HomeRoute() {
  const { session } = useAuth();

  if (session.status === 'loading') {
    return <LoadingScreen />;
  }

  return session.status === 'authenticated' ? <DashboardPage /> : <WelcomePage />;
}
